import { useState } from 'react';
import logo from '../../assets/icons/logo.svg';
import MenuIcon from '../../assets/icons/MenuIcon.svg';

function Mobile() {
  const [isOpen, setIsOpen] = useState(false);
  
  return ( 
    <div className='header'>
      <nav className={`header__menu ${isOpen ? 'flex' : 'hidden'}`}>
        <a className='header__menu-link' href="#about">О нас</a>
        <a className='header__menu-link' href="#services">Услуги</a>
        <a className='header__menu-link' href="#changes">Наш подход</a>
        <a className='header__menu-link' href="#prices">Цены</a>
        <a className='header__menu-link' href="#faq">FAQ</a>
        <a className='header__menu-link' href="#reviews">Отзывы</a>
        <a className='header__menu-link' href="#location">Контакты</a>
      </nav>
      <button className='header__menu-btn' onClick={() => {setIsOpen(!isOpen)}}>
        <img className='header__menu-img' src={MenuIcon} alt="Меню" />
      </button>
      <img className='header__logo' src={logo} alt="logo AquaTime" />
      <a className='header__button' href="https://n1386588.yclients.com"><p>Записаться</p></a>
    </div>
   );
}

export default Mobile;